/**
 * Íz típusok   * CITRON - citrom   * RASPBERRY - málna   * RED_GRAPES - vörös szőlő   * BERRY - erdei gyümölcs   * OTHER - egyéb   * COLA - cola   * GINGER - gyömbér   * TONIC - tonik   * HERB - gyógynövény   * BITTER - bitter   * ORANGE - narancs   * GRAPEFRUIT - grapefruit   * LIME - lime   * SOUR_CHERRY - meggy   * CHERRY - cseresznye   * STRAWBERRY - eper / szamóca   * SOLO - szőlő   * APPLE - alma   * PEACH - barack   * PEAR - körte    * BLUEBERRY - áfonya   * TROPICAL_FRUITS - trópusi gyümölcsök   * BLACK_BLACKBERRY - fekete szeder   * CITRUS_FRUITS - citrusok   * BLACKCURRANTS - feketeribizli   * ALOE_VERA - aloe vera   * MANGO - mangó   * CLASSIC - klasszikus   * MULTIVITAMIN - multivitamin   * COCONUT - kókusz   * GREEN_APPLE - zöldalma   * PISTACHIO - pisztácia   * ALMOND - mandula   * GRENADINE - grenadine   * KIWI - kiwi   * LYCHEE - licsi   * PASSION_FRUIT - maracuja   * CUCUMBER - uborka   * POMEGRANATE - gránátalma   * PINEAPPLE - ananász   * BLOOD_ORANGE - vérnarancs   * BLACKBERRY - szeder   * CANTALOUPE - sárgadinnye   * WATERMELON - görögdinnye   * BLUE_CURACO - blue curaco   * APRICOT - sárgabarack   * PEACH - őszibarack   * ELDERBERRY - bodza   * ROSEHIP - csipkebogyó   * ELDERFLOWER - bodzavirág
 */
export type FlavorType =
  | 'CITRON'
  | 'RASPBERRY'
  | 'RED_GRAPES'
  | 'BERRY'
  | 'OTHER'
  | 'COLA'
  | 'GINGER'
  | 'TONIC'
  | 'HERB'
  | 'BITTER'
  | 'ORANGE'
  | 'GRAPEFRUIT'
  | 'LIME'
  | 'SOUR_CHERRY'
  | 'CHERRY'
  | 'STRAWBERRY'
  | 'SOLO'
  | 'APPLE'
  | 'PEAR'
  | 'BLUEBERRY'
  | 'TROPICAL_FRUITS'
  | 'BLACK_BLACKBERRY'
  | 'CITRUS_FRUITS'
  | 'BLACKCURRANTS'
  | 'ALOE_VERA'
  | 'MANGO'
  | 'CLASSIC'
  | 'MULTIVITAMIN'
  | 'COCONUT'
  | 'GREEN_APPLE'
  | 'PISTACHIO'
  | 'ALMOND'
  | 'GRENADINE'
  | 'KIWI'
  | 'LYCHEE'
  | 'PASSION_FRUIT'
  | 'CUCUMBER'
  | 'POMEGRANATE'
  | 'PINEAPPLE'
  | 'BLOOD_ORANGE'
  | 'BLACKBERRY'
  | 'CANTALOUPE'
  | 'WATERMELON'
  | 'BLUE_CURACO'
  | 'APRICOT'
  | 'PEACH'
  | 'ELDERBERRY'
  | 'ROSEHIP'
  | 'ELDERFLOWER'
  | 'TUTTIFRUTTI';

export const FlavorType = {
  Citron: 'CITRON' as FlavorType,
  Raspberry: 'RASPBERRY' as FlavorType,
  RedGrapes: 'RED_GRAPES' as FlavorType,
  Berry: 'BERRY' as FlavorType,
  Other: 'OTHER' as FlavorType,
  Cola: 'COLA' as FlavorType,
  Ginger: 'GINGER' as FlavorType,
  Tonic: 'TONIC' as FlavorType,
  Herb: 'HERB' as FlavorType,
  Bitter: 'BITTER' as FlavorType,
  Orange: 'ORANGE' as FlavorType,
  Grapefruit: 'GRAPEFRUIT' as FlavorType,
  Lime: 'LIME' as FlavorType,
  SourCherry: 'SOUR_CHERRY' as FlavorType,
  Cherry: 'CHERRY' as FlavorType,
  Strawberry: 'STRAWBERRY' as FlavorType,
  Solo: 'SOLO' as FlavorType,
  Apple: 'APPLE' as FlavorType,
  Pear: 'PEAR' as FlavorType,
  Blueberry: 'BLUEBERRY' as FlavorType,
  TropicalFruits: 'TROPICAL_FRUITS' as FlavorType,
  BlackBlackberry: 'BLACK_BLACKBERRY' as FlavorType,
  CitrusFruits: 'CITRUS_FRUITS' as FlavorType,
  Blackcurrants: 'BLACKCURRANTS' as FlavorType,
  AloeVera: 'ALOE_VERA' as FlavorType,
  Mango: 'MANGO' as FlavorType,
  Classic: 'CLASSIC' as FlavorType,
  Multivitamin: 'MULTIVITAMIN' as FlavorType,
  Coconut: 'COCONUT' as FlavorType,
  GreenApple: 'GREEN_APPLE' as FlavorType,
  Pistachio: 'PISTACHIO' as FlavorType,
  Almond: 'ALMOND' as FlavorType,
  Grenadine: 'GRENADINE' as FlavorType,
  Kiwi: 'KIWI' as FlavorType,
  Lychee: 'LYCHEE' as FlavorType,
  PassionFruit: 'PASSION_FRUIT' as FlavorType,
  Cucumber: 'CUCUMBER' as FlavorType,
  Pomegranate: 'POMEGRANATE' as FlavorType,
  Pineapple: 'PINEAPPLE' as FlavorType,
  BloodOrange: 'BLOOD_ORANGE' as FlavorType,
  Blackberry: 'BLACKBERRY' as FlavorType,
  Cantaloupe: 'CANTALOUPE' as FlavorType,
  Watermelon: 'WATERMELON' as FlavorType,
  BlueCuraco: 'BLUE_CURACO' as FlavorType,
  Apricot: 'APRICOT' as FlavorType,
  Peach: 'PEACH' as FlavorType,
  Elderberry: 'ELDERBERRY' as FlavorType,
  Rosehip: 'ROSEHIP' as FlavorType,
  Elderflower: 'ELDERFLOWER' as FlavorType,
};

export const EnergyDrinkFlavorType = {
  ...FlavorType,
  Tuttifrutti: 'TUTTIFRUTTI' as FlavorType,
};
